var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frontend-root"},[_c('SiteNav',{attrs:{"advisor-data":_vm.advisor}}),_vm._v(" "),_c('router-view',{attrs:{"advisor":_vm.advisor,"features":_vm.features}}),_vm._v(" "),_c('DashboardMessages')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }